import { render, staticRenderFns } from "./DetailCollaborator.vue?vue&type=template&id=68473f48&"
import script from "./DetailCollaborator.vue?vue&type=script&lang=js&"
export * from "./DetailCollaborator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports